export const EXCMTAG_DELETE_RESET = 'EXCMTAG_DELETE_RESET'
export const EXCMTAG_DELETE_SET_ERROR = 'EXCMTAG_DELETE_SET_ERROR'
export const EXCMTAG_DELETE_SET_DELETED = 'EXCMTAG_DELETE_SET_DELETED'
export const EXCMTAG_DELETE_TOGGLE_LOADING = 'EXSBITEMSCATEGORY_DELETE_TOGGLE_LOADING'
